export default __webpack_public_path__ + "media/images/facebook-social-d0cc7be733be5a2f44ce8f3a31bdad7b.svg";